import type { PackRecord, ProfileRecord } from '../types';
import type { CreatorActivityItem } from './creatorActivity';
import { profileVersions } from './profileVersions';

// Preview events are separate from the catalog: they do not revise files or release dates.
export function exampleCreatorActivity(profiles: ProfileRecord[], packs: PackRecord[]): CreatorActivityItem[] {
  if (!profiles.length) return [];
  const orderedProfiles = [...profiles].sort((left, right) => left.id.localeCompare(right.id));
  const orderedPacks = [...packs].sort((left, right) => left.id.localeCompare(right.id));
  const firstProfile = orderedProfiles.find((profile) => !profile.packId) ?? orderedProfiles[0];
  const nextProfile = orderedProfiles.find((profile) => profile.id !== firstProfile.id) ?? firstProfile;
  const firstVersions = profileVersions(firstProfile);
  const nextVersions = profileVersions(nextProfile);
  const pack = orderedPacks[0];
  const examples: CreatorActivityItem[] = [
    {
      kind: 'profile', record: firstProfile, isUpdate: true, date: firstVersions[1].releasedAt,
      version: firstVersions[1].version, exampleNote: firstVersions[1].changes.join(' '),
    },
  ];
  if (pack) {
    examples.push({
      kind: 'pack', record: pack, isUpdate: true, date: firstVersions[0].releasedAt,
      version: '1.1',
      revisedCount: Math.min(3, pack.profileCount), addedCount: 0,
      exampleNote: 'Updated scaling and scanline settings across the pack.',
    });
  } else {
    examples.push({
      kind: 'profile', record: nextProfile, isUpdate: true, date: nextVersions[0].releasedAt,
      version: nextVersions[0].version, exampleNote: nextVersions[0].changes.join(' '),
    });
  }
  examples.push({
    kind: 'profile', record: nextProfile, isUpdate: true, date: nextVersions[2].releasedAt,
    version: nextVersions[2].version, exampleNote: nextVersions[2].changes.join(' '),
  });
  return examples;
}
